import { useEffect, useState } from 'react';

import { useIncidentsContext } from '../../../../../context/incidents/incidents.provider';

const useIncidentState = () => {
  const { incident, loading } = useIncidentsContext();
  const [js] = useState<any>(null);

  useEffect(() => {
    return () => {
      const bot = document.getElementsByName('Botmaker');
      // ON DID MOUNT
      if (bot && bot.length) {
        const parent = bot[0].parentElement;

        if (parent) {
          document.body.removeChild(parent);
        }
      }

      if (js) {
        document.body.removeChild(js);
      }
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const activateChat = () => {
    // const js = document.createElement("script");
    // js.type = "text/javascript";
    // js.async = true;
    // js.src =
    //   appConfig?.SHORT_NAME === SURA
    //     ? "https://go.botmaker.com/rest/webchat/p/HYKQSFD1NN/init.js"
    //     : "https://go.botmaker.com/rest/webchat/p/QQKPEAW1BH/init.js";
    // document.body.appendChild(js);
    // setJs(js);
  };

  return {
    loading,
    incident,
    activateChat,
  };
};

export default useIncidentState;
